const initialState = {
    //port List 
    loadingCCPortList: false,
    CCPortListDataError: "",
    CCPortListData: [],

    //custom house
    loadingCCCustomHouseList: true,
    CCCustomHouseListDataError: '',
    CCCustomHouseListData: [],

    //emp list
    loadingCCEmployeeList: true,
    CCEmployeeListDataError: '',
    CCEmployeeListData: [],

    //unused job order List
    loadingCCUnusedJobOrderList: true,
    CCUnusedJobOrderListData: [],
    CCUnusedJobOrderListDataError: '',

    // country list
    loadingCCCountryList: true,
    CCCountryListData: [],
    CCCountryListDataError: '',

    //custom clearance -> Export Job
    loadingCCExpJobDetail: true,
    CCExpJobDetailDataError: '',
    CCExpJobDetailData: {},

    //custom clearance -> Export Job -> organisation detail
    loadingCCExpJobOrganisationList: true,
    CCExpJobOrganisationListData: [],
    CCExpJobOrganisationListDataError: '',

    //custom clearance -> Export Job -> organisation branch detail
    loadingCCExpJobShipperOrganisationBranchList: true,
    CCExpJobShipperOrganisationBranchListData: [],
    CCExpJobShipperOrganisationBranchListDataError: '',
    //custom clearance -> Export Job -> organisation reg detail
    loadingCCExpJobShipperOrganisationRegList: false,
    CCExpJobShipperOrganisationRegListData: [],
    CCExpJobShipperOrganisationRegListDataError: '',


    loadingCCExpJobConsigneeOrganisationBranchList: true,
    CCExpJobConsigneeOrganisationBranchListData: [],
    CCExpJobConsigneeOrganisationBranchListDataError: '',

    //cc -> export job -> hsn ritc codes list
    loadingCCExpJobHSNRITCCodeList: true,
    CCExpJobHSNRITCCodeListData: [],
    CCExpJobHSNRITCCodeListDataError: '',

    //custom clearance data
    loadingJobOrderListCC: false,
    jobOrderListCCData: [],
    jobOrderListCCCurrentPage: 1,
    jobOrderListCCTotalPage: 1,
    jobOrderListCCTotalData: 1,
    jobOrderListCCStatusCount: 1,

    //custom clearance data job import
    loadingJobOrderListCCImport: false,
    jobOrderListCCImportData: [],
    jobOrderListCCImportCurrentPage: 1,
    jobOrderListCCImportTotalPage: 1,
    jobOrderListCCImportTotalData: 1,
    jobOrderListCCImportStatusCount: 1,


    //cc -> export job-> currency list
    loadingCCExpJobCurrencyList: false,
    CCExpJobCurrencyListData: [],
    CCExpJobCurrencyListDataError: '',

    //cc -> import job-> currency list
    loadingCCImportJobCurrencyList: false,
    CCImportJobCurrencyListData: [],
    CCImportJobCurrencyListDataError: '',

    //cc -> export job-> airline list
    loadingCCAirlineList: false,
    CCAirlineListData: [],
    CCAirlineListDataError: '',

    //cc -> export job-> shipline list
    loadingCCShiplineList: false,
    CCShiplineListData: [],
    CCShiplineListDataError: '',

    //cc -> export job-> invoice list
    loadingCCExpJobInvoiceList: false,
    CCExpJobInvoiceListData: [],
    CCExpJobInvoiceListDataError: '',

    //cc -> export job-> invoice detail
    loadingCCExpJobInvoiceDetail: false,
    CCExpJobInvoiceDetailData: [],
    CCExpJobInvoiceDetailDataError: '',

    //cc -> import job-> invoice list
    loadingCCImportJobInvoiceList: false,
    CCImportJobInvoiceListData: [],
    CCImportJobInvoiceListDataError: '',

    //cc -> import job-> invoice detail
    loadingCCImportJobInvoiceDetail: false,
    CCImportJobInvoiceDetailData: [],
    CCImportJobInvoiceDetailDataError: '',


    //cc -> export job -> product List
    loadingCCProductList: false,
    CCProductListData: [],
    CCProductListDataError: '',

    //cc -> export job -> product detail
    loadingCCProductDetail: false,
    CCProductDetailData: {},
    CCProductDetailDataError: '',

}

const CCReducer = (state = initialState, action) => {
    switch (action.type) {

        //port List//
        case 'FIND_CC_PORT_LIST_REQUEST':
            return {
                ...state,
                loadingCCPortList: true,
                CCPortListData: [],
                CCPortListDataError: '',
            };
        case 'FIND_CC_PORT_LIST_SUCCESS':
            return {
                ...state,
                loadingCCPortList: false,
                CCPortListData: action.payload,
            };
        case 'FIND_CC_PORT_LIST_FAILURE':
            return {
                ...state,
                loadingCCPortList: false,
                CCPortListDataError: action.payload,
            };
        //port List//

        //custom house List//
        case 'FIND_CC_CUSTOM_HOUSE_LIST_REQUEST':
            return {
                ...state,
                loadingCCCustomHouseList: true,
                CCCustomHouseListData: [],
                CCCustomHouseListDataError: '',
            };
        case 'FIND_CC_CUSTOM_HOUSE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCCustomHouseList: false,
                CCCustomHouseListData: action.payload,
            };
        case 'FIND_CC_CUSTOM_HOUSE_LIST_FAILURE':
            return {
                ...state,
                loadingCCCustomHouseList: false,
                CCCustomHouseListDataError: action.payload,
            };
        //custom house List//

        //employee List//
        case 'FIND_CC_EMPLOYEE_LIST_REQUEST':
            return {
                ...state,
                loadingCCEmployeeList: true,
                CCEmployeeListData: [],
                CCEmployeeListDataError: '',
            };
        case 'FIND_CC_EMPLOYEE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCEmployeeList: false,
                CCEmployeeListData: action.payload,
            };
        case 'FIND_CC_EMPLOYEE_LIST_FAILURE':
            return {
                ...state,
                loadingCCEmployeeList: false,
                CCEmployeeListDataError: action.payload,
            };
        //employee List//

        //unused job order List//
        case 'FIND_CC_UNUSED_JOBORDER_LIST_REQUEST':
            return {
                ...state,
                loadingCCUnusedJobOrderList: true,
                CCUnusedJobOrderListData: [],
                CCUnusedJobOrderListDataError: '',
            };
        case 'FIND_CC_UNUSED_JOBORDER_LIST_SUCCESS':
            return {
                ...state,
                loadingCCUnusedJobOrderList: false,
                CCUnusedJobOrderListData: action.payload,
            };
        case 'FIND_CC_UNUSED_JOBORDER_LIST_FAILURE':
            return {
                ...state,
                loadingCCUnusedJobOrderList: false,
                CCUnusedJobOrderListDataError: action.payload,
            };
        //unused job order List//

        //country List//
        case 'FIND_CC_COUNTRY_LIST_REQUEST':
            return {
                ...state,
                loadingCCCountryList: true,
                CCCountryListData: [],
                CCCountryListDataError: '',
            };
        case 'FIND_CC_COUNTRY_LIST_SUCCESS':
            return {
                ...state,
                loadingCCCountryList: false,
                CCCountryListData: action.payload,
            };
        case 'FIND_CC_COUNTRY_LIST_FAILURE':
            return {
                ...state,
                loadingCCCountryList: false,
                CCCountryListDataError: action.payload,
            };
        //country List//

        //custom clearance-> export job //
        case 'FIND_CC_EXP_JOB_DETAIL_REQUEST':

            return {
                ...state,
                loadingCCExpJobDetail: true,
                CCExpJobDetailData: {},
                CCExpJobDetailDataError: '',
            };
        case 'FIND_CC_EXP_JOB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCExpJobDetail: false,
                CCExpJobDetailData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCExpJobDetail: false,
                CCExpJobDetailDataError: action.payload,
            };
        //custom clearance-> export job //

        //custom clearance-> export job -> organisation list //
        case 'FIND_CC_EXP_JOB_ORGANISATION_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobOrganisationList: true,
                CCExpJobOrganisationListData: [],
                CCExpJobOrganisationListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_ORGANISATION_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobOrganisationList: false,
                CCExpJobOrganisationListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_ORGANISATION_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobOrganisationList: false,
                CCExpJobOrganisationListDataError: action.payload,
            };
        //custom clearance-> export job -> organisation list //

        //custom clearance-> export job -> organisation branch list //
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobShipperOrganisationBranchList: true,
                CCExpJobShipperOrganisationBranchListData: [],
                CCExpJobShipperOrganisationBranchListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobShipperOrganisationBranchList: false,
                CCExpJobShipperOrganisationBranchListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobShipperOrganisationBranchList: false,
                CCExpJobShipperOrganisationBranchListDataError: action.payload,
            };
        //custom clearance-> export job -> organisation reg list //
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobShipperOrganisationRegList: true,
                CCExpJobShipperOrganisationRegListData: [],
                CCExpJobShipperOrganisationRegListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobShipperOrganisationRegList: false,
                CCExpJobShipperOrganisationRegListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobShipperOrganisationRegList: false,
                CCExpJobShipperOrganisationRegListDataError: action.payload,
            };
        case 'FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobConsigneeOrganisationBranchList: true,
                CCExpJobConsigneeOrganisationBranchListData: [],
                CCExpJobConsigneeOrganisationBranchListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobConsigneeOrganisationBranchList: false,
                CCExpJobConsigneeOrganisationBranchListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobConsigneeOrganisationBranchList: false,
                CCExpJobConsigneeOrganisationBranchListDataError: action.payload,
            };
        //custom clearance-> export job -> organisation branch list //

        // custom clearance -> export job Order List
        case 'FIND_JOB_ORDER_LIST_CC_REQUEST':
            return {
                ...state,
                loadingJobOrderListCC: true,
                jobOrderListCCData: [],
                jobOrderListCCDataError: '',
            };
        case 'FIND_JOB_ORDER_LIST_CC_SUCCESS':
            return {
                ...state,
                loadingJobOrderListCC: false,
                jobOrderListCCData: action.payload.data,
                jobOrderListCCCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                jobOrderListCCTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                jobOrderListCCTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 1,
                jobOrderListCCStatusCount: action.payload.getCount,
            };
        case 'FIND_JOB_ORDER_LIST_CC_FAILURE':
            return {
                ...state,
                loadingJobOrderListCC: false,
                jobOrderListCCDataError: action.payload,
            };
        //Job Order List//


        //cc -> export job -> hsn ritc codes list
        case 'FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobHSNRITCCodeList: true,
                CCExpJobHSNRITCCodeListData: [],
                CCExpJobHSNRITCCodeListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobHSNRITCCodeList: false,
                CCExpJobHSNRITCCodeListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobHSNRITCCodeList: false,
                CCExpJobHSNRITCCodeListDataError: action.payload,
            };
        //cc -> export job -> hsn ritc codes list


        //cc -> export job -> currency list
        case 'FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobCurrencyList: true,
                CCExpJobCurrencyListData: [],
                CCExpJobCurrencyListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobCurrencyList: false,
                CCExpJobCurrencyListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobCurrencyList: false,
                CCExpJobCurrencyListDataError: action.payload,
            };
        //cc -> export job -> currency list

        //cc -> export job -> airline list
        case 'FIND_CC_AIRLINE_LIST_REQUEST':

            return {
                ...state,
                loadingCCAirlineList: true,
                CCAirlineListData: [],
                CCAirlineListDataError: '',
            };
        case 'FIND_CC_AIRLINE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCAirlineList: false,
                CCAirlineListData: action.payload,
            };
        case 'FIND_CC_AIRLINE_LIST_FAILURE':
            return {
                ...state,
                loadingCCAirlineList: false,
                CCAirlineListDataError: action.payload,
            };
        //cc -> export job -> airline list

        //cc -> export job -> shipine list
        case 'FIND_CC_SHIPLINE_LIST_REQUEST':

            return {
                ...state,
                loadingCCShiplineList: true,
                CCShiplineListData: [],
                CCShiplineListDataError: '',
            };
        case 'FIND_CC_SHIPLINE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCShiplineList: false,
                CCShiplineListData: action.payload,
            };
        case 'FIND_CC_SHIPLINE_LIST_FAILURE':
            return {
                ...state,
                loadingCCShiplineList: false,
                CCShiplineListDataError: action.payload,
            };
        //cc -> export job -> shipine list

        //cc -> export job -> invoice list
        case 'FIND_CC_EXP_JOB_INVOICE_LIST_REQUEST':
            return {
                ...state,
                loadingCCExpJobInvoiceList: true,
                CCExpJobInvoiceListData: [],
                CCExpJobInvoiceListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_INVOICE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobInvoiceList: false,
                CCExpJobInvoiceListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_INVOICE_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobInvoiceList: false,
                CCExpJobInvoiceListDataError: action.payload,
            };
        //cc -> export job -> invoice list

        //cc -> export job -> invoice detail
        case 'FIND_CC_EXP_JOB_INVOICE_DETAIL_REQUEST':
            return {
                ...state,
                loadingCCExpJobInvoiceDetail: true,
                CCExpJobInvoiceDetailData: [],
                CCExpJobInvoiceDetailDataError: '',
            };
        case 'FIND_CC_EXP_JOB_INVOICE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCExpJobInvoiceDetail: false,
                CCExpJobInvoiceDetailData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_INVOICE_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCExpJobInvoiceDetail: false,
                CCExpJobInvoiceDetailDataError: action.payload,
            };
        //cc -> export job -> invoice detail

        // custom clearance -> Import job Order List
        case 'FIND_JOB_ORDER_LIST_IMPORT_CC_REQUEST':
            return {
                ...state,
                loadingJobOrderListCCImport: true,
                jobOrderListCCImportData: [],
                jobOrderListCCImportDataError: '',
            };
        case 'FIND_JOB_ORDER_LIST_IMPORT_CC_SUCCESS':
            return {
                ...state,
                loadingJobOrderListCCImport: false,
                jobOrderListCCImportData: action.payload.data,
                jobOrderListCCImportCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                jobOrderListCCImportTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                jobOrderListCCImportTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 1,
                jobOrderListCCImportStatusCount: action.payload.getCount,
            };
        case 'FIND_JOB_ORDER_LIST_IMPORT_CC_FAILURE':
            return {
                ...state,
                loadingJobOrderListCCImport: false,
                jobOrderListCCImportDataError: action.payload,
            };
        //Job Order Import List//
        //cc -> export job -> product List
        case 'FIND_CC_EXP_PRODUCT_LIST_REQUEST':
            return {
                ...state,
                loadingCCProductList: true,
                CCProductListData: [],
                CCProductListDataError: '',
            };
        case 'FIND_CC_EXP_PRODUCT_LIST_SUCCESS':
            return {
                ...state,
                loadingCCProductList: false,
                CCProductListData: action.payload,
            };
        case 'FIND_CC_EXP_PRODUCT_LIST_FAILURE':
            return {
                ...state,
                loadingCCProductList: false,
                CCProductListDataError: action.payload,
            };
        //cc -> export job -> product List

        //cc -> export job -> product detail
        case 'FIND_CC_EXP_PRODUCT_DETAIL_REQUEST':
            return {
                ...state,
                loadingCCProductDetail: true,
                CCProductDetailData: {},
                CCProductDetailDataError: '',
            };
        case 'FIND_CC_EXP_PRODUCT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCProductDetail: false,
                CCProductDetailData: action.payload,
            };
        case 'FIND_CC_EXP_PRODUCT_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCProductDetail: false,
                CCProductDetailDataError: action.payload,
            };
        //cc -> export job -> product detail

        //cc -> import job -> invoice list
        case 'FIND_CC_IMPORT_JOB_INVOICE_LIST_REQUEST':
            return {
                ...state,
                loadingCCImportJobInvoiceList: true,
                CCImportJobInvoiceListData: [],
                CCImportJobInvoiceListDataError: '',
            };
        case 'FIND_CC_IMPORT_JOB_INVOICE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCImportJobInvoiceList: false,
                CCImportJobInvoiceListData: action.payload,
            };
        case 'FIND_CC_IMPORT_JOB_INVOICE_LIST_FAILURE':
            return {
                ...state,
                loadingCCImportJobInvoiceList: false,
                CCImportJobInvoiceListDataError: action.payload,
            };
        //cc -> export job -> invoice list

        //cc -> export job -> invoice detail
        case 'FIND_CC_IMPORT_JOB_INVOICE_DETAIL_REQUEST':
            return {
                ...state,
                loadingCCImportJobInvoiceDetail: true,
                CCImportJobInvoiceDetailData: [],
                CCImportJobInvoiceDetailDataError: '',
            };
        case 'FIND_CC_IMPORT_JOB_INVOICE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCImportJobInvoiceDetail: false,
                CCImportJobInvoiceDetailData: action.payload,
            };
        case 'FIND_CC_IMPORT_JOB_INVOICE_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCImportJobInvoiceDetail: false,
                CCImportJobInvoiceDetailDataError: action.payload,
            };
        //cc -> export job -> invoice detail

        //cc -> export job -> currency list
        case 'FIND_CC_IMPORT_JOB_HSN_CURRENCY_LIST_REQUEST':

            return {
                ...state,
                loadingCCImportJobCurrencyList: true,
                CCImportJobCurrencyListData: [],
                CCImportJobCurrencyListDataError: '',
            };
        case 'FIND_CC_IMPORT_JOB_HSN_CURRENCY_LIST_SUCCESS':
            return {
                ...state,
                loadingCCImportJobCurrencyList: false,
                CCImportJobCurrencyListData: action.payload,
            };
        case 'FIND_CC_IMPORT_JOB_HSN_CURRENCY_LIST_FAILURE':
            return {
                ...state,
                loadingCCImportJobCurrencyList: false,
                CCImportJobCurrencyListDataError: action.payload,
            };
        //cc -> export job -> currency list

        default:
            return state;
    }
}

export default CCReducer;